export const environment = {
  production: true,
  // Clave pública (site key) de Cloudflare Turnstile. Vacía = sin widget y sin
  // bloquear el envío del formulario de /michollo-team/ (app-turnstile no pinta nada).
  turnstileSiteKey: '',
  // Proyecto «michollo-app»: el mismo cuyas credenciales usa el servidor de avisos
  // (/home/michollo/fmc-server). Con otro proyecto cada envío falla (mismatched-credential).
  firebase: {
    apiKey: "AIzaSyBDJrSzP8C_5yxSNXSoAz9eqLb6w5Q6Fpk",
    authDomain: "michollo-app.firebaseapp.com",
    databaseURL: "https://michollo-app.firebaseio.com",
    projectId: "michollo-app",
    storageBucket: "michollo-app.firebasestorage.app",
    messagingSenderId: "956830590536",
    appId: "1:956830590536:web:6175e71345242fbac45a7d",
    measurementId: "G-T4L1EVRP8V",
    vapidKey: 'BHI6b_UzYsaCKQ3Z4Xjr62HuKvPrwtzWcP3us8fKeRaOILw5aaCtYKJgvl1OfMi04I7r0t1GYt6w3ZN69WwCrf8',
  },
};
